<template>
    <div>
        <input type="hidden" v-bind="$props" :value="JSON.stringify(currentValue)">
        <LocationSearchControl :value="currentValue" @input="currentValue = $event" :placeholder="$props.placeholder"/>
    </div>
</template>

<script lang="ts">
import LocationSearchControl from '@/components/common/LocationSearchControl.vue';
import {SearchResultItem} from '@/model/api/search';
import {defineComponent, ref} from 'vue';

export default defineComponent({
    components: {LocationSearchControl},
    props: {
        'data-nette-rules': {type: String},
        'name': {type: String},
        'value': {type: String, required: true},
        'placeholder': {type: String},
    },
    setup(props) {
        const currentValue = ref<SearchResultItem | null>(JSON.parse(props.value));

        return {currentValue};
    },
});
</script>
